/* eslint-disable comma-dangle, no-var, react/jsx-closing-bracket-location, react/prop-types, react/sort-comp */
/* TODO(csilvers): fix these lint errors (http://eslint.org/docs/rules): */
/* To fix, remove an entry above, run ka-lint, and fix errors. */

var React = require("react");
var ReactDOM = require("react-dom");
var _ = require("underscore");

var Util = require("../util.js");

var InfoTip = require("../components/info-tip.jsx");
var NumberInput = require("../components/number-input.jsx");
var Editor = require("../editor.jsx");

var Table = require("./table.jsx").widget;

var TableEditor = React.createClass({
    displayName: "TableEditor",

    propTypes: {
        rows: React.PropTypes.number,
        columns: React.PropTypes.number,
        headers: React.PropTypes.arrayOf(React.PropTypes.string),
        answers: React.PropTypes.arrayOf(React.PropTypes.arrayOf(React.PropTypes.string))
    },

    getDefaultProps: function getDefaultProps() {
        var defaultRows = 4;
        var defaultColumns = 1;
        var blankAnswers = _(defaultRows).times(function () {
            return Util.stringArrayOfSize(defaultColumns);
        });
        return {
            headers: [""],
            rows: defaultRows,
            columns: defaultColumns,
            answers: blankAnswers
        };
    },

    focus: function focus() {
        ReactDOM.findDOMNode(this.refs.numberOfColumns).focus();
    },

    render: function render() {
        var _this = this;

        var tableProps = _.pick(this.props, "headers", "answers", "onChange", "apiOptions");
        _.extend(tableProps, {
            editableHeaders: true,
            Editor: Editor,
            onFocus: function onFocus() {},
            onBlur: function onBlur() {},
            trackInteraction: function trackInteraction() {}
        });

        return React.createElement(
            "div",
            null,
            React.createElement(
                "div",
                { className: "perseus-widget-row" },
                React.createElement(
                    "label",
                    null,
                    "Number of columns:",
                    " ",
                    React.createElement(NumberInput, {
                        ref: "numberOfColumns",
                        value: this.props.columns,
                        onChange: function onChange(val) {
                            if (val) {
                                _this.onSizeInput(_this.props.rows, val);
                            }
                        },
                        useArrowKeys: true
                    })
                )
            ),
            React.createElement(
                "div",
                { className: "perseus-widget-row" },
                React.createElement(
                    "label",
                    null,
                    "Number of rows:",
                    " ",
                    React.createElement(NumberInput, {
                        ref: "numberOfRows",
                        value: this.props.rows,
                        onChange: function onChange(val) {
                            if (val) {
                                _this.onSizeInput(val, _this.props.columns);
                            }
                        },
                        useArrowKeys: true
                    })
                )
            ),
            React.createElement(
                "div",
                null,
                " ",
                "Table of answers:",
                " ",
                React.createElement(
                    InfoTip,
                    null,
                    React.createElement(
                        "p",
                        null,
                        "The student has to fill out all cells in the table. For partially filled tables create a table using the template, and insert text input boxes as desired."
                    )
                )
            ),
            React.createElement(
                "div",
                null,
                React.createElement(Table, tableProps)
            )
        );
    },

    onSizeInput: function onSizeInput(numRawRows, numRawColumns) {
        var rows = +numRawRows || 0;
        var columns = +numRawColumns || 0;
        rows = Math.min(Math.max(1, rows), 30);
        columns = Math.min(Math.max(1, columns), 6);
        var oldColumns = this.props.columns;
        var oldRows = this.props.rows;

        var answers = this.props.answers;
        // Truncate if necessary; else, append
        if (rows <= oldRows) {
            answers.length = rows;
        } else {
            _(rows - oldRows).times(function () {
                answers.push(Util.stringArrayOfSize(oldColumns));
            });
        }

        function fixColumnSizing(array) {
            // Truncate if necessary; else, append
            if (columns <= oldColumns) {
                array.length = columns;
            } else {
                _(columns - oldColumns).times(function () {
                    array.push("");
                });
            }
        }

        var headers = this.props.headers;
        fixColumnSizing(headers);
        _.each(answers, fixColumnSizing);

        this.props.onChange({
            rows: rows,
            columns: columns,
            answers: answers,
            headers: headers
        });
    },

    serialize: function serialize() {
        var json = _.pick(this.props, "headers", "rows", "columns");

        return _.extend({}, json, {
            answers: _.map(this.props.answers, _.clone)
        });
    }
});

module.exports = TableEditor;


/*****************
 ** WEBPACK FOOTER
 ** ./src/widgets/table-editor.jsx
 ** module id = 151
 ** module chunks = 0 1
 **/